
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#command-launch-type-every-login_svg__clip0_1609_11583)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.421 0A3.333 3.333 0 00.088 3.333v2.829a.91.91 0 001.818 0V3.333c0-.836.678-1.515 1.515-1.515h.363c-.232.455-.363.97-.363 1.515v2.829a.91.91 0 001.818 0V3.333c0-.836.679-1.515 1.515-1.515h.364a3.32 3.32 0 00-.364 1.515v2.829a.91.91 0 001.819 0V3.333c0-.836.678-1.515 1.515-1.515h6.578c.837 0 1.516.679 1.516 1.515v13.334c0 .836-.679 1.515-1.515 1.515H10.087a1.515 1.515 0 01-1.515-1.515v-2.829a.91.91 0 10-1.819 0v2.829c0 .545.132 1.06.364 1.515h-.364a1.515 1.515 0 01-1.515-1.515v-2.829a.91.91 0 10-1.818 0v2.829c0 .545.131 1.06.363 1.515h-.363a1.515 1.515 0 01-1.515-1.515v-2.829a.91.91 0 00-1.818 0v2.829A3.333 3.333 0 003.42 20H16.666A3.333 3.333 0 0020 16.667V3.333A3.333 3.333 0 0016.666 0H3.421zm7.16 5.266a.91.91 0 00-1.287 1.286l2.691 2.69H.91a.91.91 0 100 1.819h11.076l-2.69 2.69a.909.909 0 101.285 1.286l4.243-4.243a.91.91 0 000-1.285L10.58 5.266z","fill":"#202D38"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"command-launch-type-every-login_svg__clip0_1609_11583"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    